import gql from 'graphql-tag';

export default gql`
  query orderStatusHistoryDetail($searchRequest: OrderHistoryDetailInput!) {
    orderStatusHistoryDetail(searchRequest: $searchRequest) {
      total
      totalPage
      dataList {
        id
        objectId
        objectType
        actioner
        name
        email
        clientId
        actionType
        time
        dateTime
        oldData
        newData
      }
    }
  }
`;
